import Phaser from 'phaser';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super('PreloadScene');
  }

  public preload(): void {
    // Additional asset loading hooks
  }

  public create(): void {
    this.scene.start('MainMenuScene');
  }
}
